import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useDrop } from 'vue3-dnd'
import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DropZone',
  props: {
    targetId: {}
  },
  emits: ["move-row"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const dropEl = ref<HTMLElement | null>(null)

// useDrop возвращает [collectRef, drop]
const [collect, drop] = useDrop(() => ({
  accept: 'ROW',
  drop: (item: any) => {
    emit('move-row', item.sourceId, props.targetId, item.row)
  },
  collect: (monitor) => ({
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  })
}))

onMounted(() => {
  if (dropEl.value) drop(dropEl.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'drop-hover': _unref(collect).isOver && _unref(collect).canDrop }),
    ref_key: "dropEl",
    ref: dropEl
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})